var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowDownSvg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 4.168v11.667M15.834 10 10 15.833 4.167 10",
  stroke: "#D82011",
  strokeWidth: 2,
  strokeLinejoin: "round"
})));
export default SvgArrowDownSvg;